import React from 'react';
import { Spinner } from "react-bootstrap";
import {Link} from "react-router-dom";

const ButtonSecondary = (
    {
        children = null,
        text,
        isLoading,
        className="",
        onClick = () => {},
        href
    }
) => {
    if (href) {
        if (href.startsWith('tel:')) {
            // Handle telephone links
            return (
                <a href={href} className={`button-secondary td-none ${className}`} aria-disabled={isLoading}>
                    <div className={'mobile-button-small ' + (isLoading ? 'd-none' : 'd-block')}>
                        {text}
                        {children}
                    </div>
                    <Spinner
                        className={'custom-spinner ' + (isLoading ? 'd-inline-block' : 'd-none')}
                        animation='border'
                    />
                </a>
            );
        }

        // Handle internal routing links
        return (
            <Link to={href} className={`button-secondary ${className}`} aria-disabled={isLoading}>
                <div className={'mobile-button-small ' + (isLoading ? 'd-none' : 'd-block')}>
                    {text}
                    {children}
                </div>
                <Spinner
                    className={'custom-spinner ' + (isLoading ? 'd-inline-block' : 'd-none')}
                    animation='border'
                />
            </Link>
        );
    }
    return (
        <button onClick={onClick} className={`button-secondary ${className}`}>
            <div className={'mobile-button-small ' + (isLoading ? 'd-none' : 'd-block')}>
                {text}
                {children}
            </div>
            <Spinner
                className={'custom-spinner ' + (isLoading ? 'd-inline-block' : 'd-none')}
                animation='border'
            />
        </button>
    );
};

export default ButtonSecondary;
